import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ecs-http-progressbar"},[_c(VProgressCircular,{staticClass:"http-progressbar",class:{ show: _vm.requestCount && _vm.realProgressValue !== 100 },attrs:{"color":_vm.$vuetify.theme.dark ? 'var(--v-accent-base)' : 'var(--v-surface-base)',"size":"36","width":"3","indeterminate":""}},[_c('span',{staticClass:"progress-label"},[_vm._v(_vm._s(_vm.realProgressValue)+"%")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }